import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractChanges  {
    _originalTypeClassName = "zERP.BO.EmployeeContractChanges";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractChanges.translate = translateService;
}
this.Id = null;
this.Contract_Id = null;
this.StartDate = null;
this.EndDate = null;
this.SalaryChg = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Contract_Id:any;
StartDate:any;
EndDate:any;
SalaryChg:any;
Branch:any;
FloorHst:any;
DepartmentHst:any;
SuperVisor:any;
DepPositionHst:any;
LocationHst:any;
static setBranch = ($this, value) => {
var oldValue = $this.Branch;
$this.Branch = value;
if (value != null) {
}
}
static setFloorHst = ($this, value) => {
var oldValue = $this.FloorHst;
$this.FloorHst = value;
if (value != null) {
}
}
static setDepartmentHst = ($this, value) => {
var oldValue = $this.DepartmentHst;
$this.DepartmentHst = value;
if (value != null) {
}
}
static setSuperVisor = ($this, value) => {
var oldValue = $this.SuperVisor;
$this.SuperVisor = value;
if (value != null) {
}
}
static setDepPositionHst = ($this, value) => {
var oldValue = $this.DepPositionHst;
$this.DepPositionHst = value;
if (value != null) {
}
}
static setLocationHst = ($this, value) => {
var oldValue = $this.LocationHst;
$this.LocationHst = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}